/* custom-header.js (2026-08-27 追加)
 * 目的: ヘッダー導線（デスクトップのカテゴリ行 / モバイルのカテゴリ行 / ドロワー / 検索）の
 *       利用を GA4 で実測できるようにする。「ヘッダーメニューがほとんど使われていない」は
 *       これまでページ/セッション数からの推定でしかなかった。
 *
 * 送信の仕組み: このストアは GA4 タグ (G-7MS3LL2J04) を初期表示では読み込まない
 *       （custom-marketplace-tracking.js が初回モールクリック時に遅延読込する設計で、
 *       約176KB を初期表示から外している）。ヘッダーのリンクは同一サイト内遷移なので、
 *       クリック時に gtag を読み込んでから送ろうとすると、まず間に合わない。
 *       そこで sessionStorage にいったん積み、次のページの idle 時にまとめて送る。
 *       gtag が既にページにいる場合はその場で送る。
 *
 * 副作用を持たせない方針: preventDefault で遷移を止めない（中クリックと修飾キーの
 *       新規タブを壊すため）。pointerdown も使わない（横スクロールするカテゴリ行で
 *       指を置いただけで発火するため）。
 */
(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-7MS3LL2J04';
  var QUEUE_KEY = 'tc_header_events';
  var MAX_QUEUE = 30;

  function readQueue() {
    try {
      var raw = sessionStorage.getItem(QUEUE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Object.prototype.toString.call(parsed) === '[object Array]' ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function writeQueue(list) {
    try {
      sessionStorage.setItem(QUEUE_KEY, JSON.stringify(list.slice(-MAX_QUEUE)));
    } catch (e) {
      /* プライベートモード等で書けなくても計測以外に影響を出さない */
    }
  }

  function clearQueue() {
    try {
      sessionStorage.removeItem(QUEUE_KEY);
    } catch (e) {
      /* noop */
    }
  }

  function gtagLibPresent() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if ((scripts[i].src || '').indexOf('googletagmanager.com/gtag/js') > -1) return true;
    }
    return false;
  }

  var configured = false;
  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
    }
    if (!gtagLibPresent()) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
      document.head.appendChild(s);
    }
    if (!configured) {
      configured = true;
      window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    }
  }

  function sendNow(entry) {
    var params = {};
    for (var k in entry.params) {
      if (Object.prototype.hasOwnProperty.call(entry.params, k)) params[k] = entry.params[k];
    }
    params.send_to = MEASUREMENT_ID;
    params.transport_type = 'beacon';
    window.gtag('event', entry.name, params);
  }

  function enqueue(name, params) {
    if (typeof window.gtag === 'function' && gtagLibPresent()) {
      ensureGtag();
      sendNow({ name: name, params: params });
      return;
    }
    var list = readQueue();
    list.push({ name: name, params: params });
    writeQueue(list);
  }

  function flush() {
    var list = readQueue();
    if (!list.length) return;
    if (navigator.connection && navigator.connection.saveData) return;
    ensureGtag();
    if (typeof window.gtag !== 'function') return;
    clearQueue();
    for (var i = 0; i < list.length; i++) sendNow(list[i]);
  }

  function whenIdle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 4000 });
    } else {
      window.setTimeout(fn, 2500);
    }
  }

  function onClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-ga-surface]') : null;
    if (!a) return;
    enqueue('header_nav_click', {
      surface: a.getAttribute('data-ga-surface') || '',
      label: a.getAttribute('data-ga-label') || '',
      position: parseInt(a.getAttribute('data-ga-position'), 10) || 0,
      link_url: a.href || ''
    });
  }

  function onSearchFocus(e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('input[type="search"][data-ga-surface]')) return;
    if (el.dataset.gaSent === '1') return;
    el.dataset.gaSent = '1';
    enqueue('header_search_open', { surface: el.getAttribute('data-ga-surface') || '' });
  }

  function onSearchModalToggle(e) {
    var summary = e.target && e.target.closest ? e.target.closest('.header__icon--search') : null;
    if (!summary) return;
    var details = summary.parentElement;
    if (details && details.hasAttribute('open')) return;
    enqueue('header_search_open', { surface: 'mobile_icon' });
  }

  function onLogoClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('.header__heading-link') : null;
    if (!a) return;
    enqueue('header_logo_click', {});
  }

  document.addEventListener('click', onClick, true);
  document.addEventListener('click', onSearchModalToggle, true);
  document.addEventListener('click', onLogoClick, true);
  document.addEventListener('focusin', onSearchFocus, true);

  /* カテゴリ行を開いたとき、現在地のカテゴリが見える位置まで横スクロールしておく */
  function scrollChipsToCurrent() {
    var scroller = document.querySelector('.custom-category-chips__scroller');
    if (!scroller) return;
    var current = scroller.querySelector('.custom-category-chips__link--current');
    if (!current) return;
    var target = current.offsetLeft - (scroller.clientWidth - current.offsetWidth) / 2;
    scroller.scrollLeft = target > 0 ? target : 0;
  }

  function init() {
    scrollChipsToCurrent();
    whenIdle(flush);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
